import React, { Component }  from 'react';
import queryString from 'query-string';

const ssoUrl = (route) => {
  const params = {
    returnUrl: process.env.REACT_APP_ADS_URL + '/#/callback/'
  }
  return `${process.env.REACT_APP_SSO_URL}/${process.env.REACT_APP_ADS_SSO_CLIENT_ID}/${route}?${queryString.stringify(params)}`
}
class AppLoginPage extends Component {

  componentDidMount = () => {
    const { REACT_APP_SSO_URL, REACT_APP_ADS_SSO_CLIENT_ID, REACT_APP_ADS_URL } = process.env
    if ( REACT_APP_SSO_URL && REACT_APP_ADS_SSO_CLIENT_ID && REACT_APP_ADS_URL )
    {
      window.location.href = ssoUrl('sso_login')
    }
  }

  render() {
      return <p>Login</p>;
  }
}

export default AppLoginPage;
